import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitPeriods = createSelector(
  [selectFinancialCockpitState],
  ({ selectedPeriods }) => selectedPeriods
)
